// src/balances/index.js
// Balances — extracted from index.html (v105.x sprint, auto-generated header).
// Bundled by esbuild into dist/balances.js. The HTML loads it via
//   <script src="dist/balances.js"></script>
// and call sites use `Balances.<sub>.<fn>()` (e.g.
//   Balances.holidays.getHolidaysForStore()
//   Balances.calc.getProjectedToil()
//   Balances.area.renderAreaBalancesTab()
//   Balances.toil.onToilTabOpen()
// ).
//
// Backwards compat: index.html's trailing script block re-exposes the
// moved functions on window so existing call sites — both inline JS and
// onclick="" attributes — keep working without HTML edits.
//
// Free variables (DB, currentUser, currentStore, escapeHtml, WORKER_URL,
// fetch, console, document, window, ...) live in the inline globals
// scope of index.html. esbuild leaves them as bare references at runtime.

// ── holidays ─────────────────────────────────────────────
export const holidays = {};

function getHolidaysForStore(store) {
  // Try localStorage first (written by admin Public Holidays tab)
  try {
    var saved = localStorage.getItem('elc_holidays_data');
    if (saved) {
      var data = JSON.parse(saved);
      return getStoreCountry(store) === 'ELC - Qatar' ? (data.Qatar || []) : (data.UAE || []);
    }
  } catch(e) {}
  // Fall back to hardcoded defaults
  return getStoreCountry(store) === 'ELC - Qatar' ? PUBLIC_HOLIDAYS.Qatar : PUBLIC_HOLIDAYS.UAE;
}
holidays.getHolidaysForStore = getHolidaysForStore;

function getHolidayForDate(store,dateStr) { return getHolidaysForStore(store).find(function(h){return h.date===dateStr;})||null; }
holidays.getHolidayForDate = getHolidayForDate;

// ── calc ─────────────────────────────────────────────
export const calc = {};

function getProjectedToil(staffId) {
  if (!shifts || typeof shifts !== 'object') return 0;
  var staff = ALL_STAFF.find(function(x){ return x.id === staffId; });
  if (!staff || !staff.store) return 0;
  var country = getStoreCountry(staff.store);  // 'ELC - UAE' or 'ELC - Qatar'
  // Build a fast lookup of holiday dates for this country.
  var holidays = getHolidaysForStore(staff.store);  // array of {date, name}
  if (!holidays || !holidays.length) return 0;
  var holidayDates = {};
  holidays.forEach(function(h){ holidayDates[h.date] = true; });

  var todayCutoff = todayStr();  // localDateStr-equivalent for today
  var DAY_KEYS = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
  var totalH = 0;

  Object.keys(shifts).forEach(function(key){
    // Key format: YYYY-MM-DD_staffId_DayAbbr  (e.g. 2026-05-25_42_Tue)
    var parts = key.split('_');
    if (parts.length < 3) return;
    var weekStart = parts[0];
    var sid = parseInt(parts[1]);
    var dayAbbr = parts[2];
    if (sid !== staffId) return;
    if (DAY_KEYS.indexOf(dayAbbr) === -1) return;

    var sh = shifts[key];
    if (!sh || sh.type !== 'work') return;
    if (!sh.start || !sh.finish) return;

    // Compute shift's actual date from week_start + day offset.
    // v136.8: the offset counts from week_start's OWN weekday (Sunday in Qatar), as getBookedHolidayDays does.
    var JS_DOW = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var dayOffset = (JS_DOW[dayAbbr] - new Date(weekStart + 'T12:00:00Z').getUTCDay() + 7) % 7;
    if (isNaN(dayOffset)) return;
    var shiftDate = shiftDateStr(weekStart, dayOffset);
    if (shiftDate < todayCutoff) return;     // past — already accrued (or missed)
    if (!holidayDates[shiftDate]) return;    // not a public holiday

    // Hours = finish - start - lunch (in minutes, then ÷60)
    var workedMins = timeMins(sh.finish) - timeMins(sh.start);
    if (workedMins < 0) workedMins += 24 * 60;  // overnight wrap
    var lunchMins = sh.lunch || 0;
    var hours = (workedMins - lunchMins) / 60;
    if (hours > 0) totalH += hours;
  });

  return Math.round(totalH * 10) / 10;
}
calc.getProjectedToil = getProjectedToil;

function getBookedHolidayDays(staffId) {
  if (!shifts || typeof shifts !== 'object') return 0;
  var todayCutoff = todayStr();
  var DAY_KEYS = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
  var count = 0;
  Object.keys(shifts).forEach(function(key){
    var parts = key.split('_');
    if (parts.length < 3) return;
    var weekStart = parts[0];
    var sid = parseInt(parts[1]);
    var dayAbbr = parts[2];
    if (sid !== staffId) return;
    if (DAY_KEYS.indexOf(dayAbbr) === -1) return;
    var sh = shifts[key];
    if (!sh || sh.type !== 'holiday') return;
    // v136.8 (16 Oct audit): count from week_start's OWN weekday (Sunday in Qatar), never a Mon-first table:
    // a Qatar holiday was dated a day early, so a booking for TODAY read as past and was not counted.
    // A Monday week gives exactly the old offset. (docs/field-lessons.md "The Monday assumption".)
    var JS_DOW = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var dayOffset = (JS_DOW[dayAbbr] - new Date(weekStart + 'T12:00:00Z').getUTCDay() + 7) % 7;
    if (isNaN(dayOffset)) return;          // not a real week_start: never guess a date
    var shiftDate = shiftDateStr(weekStart, dayOffset);
    if (shiftDate < todayCutoff) return;   // past — already counted as 'used'
    count++;
  });
  return count;
}
calc.getBookedHolidayDays = getBookedHolidayDays;

function getToilSummary(staffId){
  var today=new Date();today.setHours(0,0,0,0);
  var EXPIRY_DAYS=30;
  var txs=toilTransactions.filter(function(t){return t.staffId===staffId;});
  // v79.15.1 — toilTransactions[] is in-memory only (transactions aren't
  // persisted). On a fresh page load, txs is empty even when toil_balance
  // in DB is non-zero. Fall back to toilBalances[staffId] for the net
  // total in that case, so the Balances tab shows the right number for
  // staff who earned/took TOIL in a previous session.
  if (txs.length === 0) {
    var dbNet = toilBalances[staffId] || 0;
    return {
      earned: dbNet > 0 ? Math.round(dbNet*10)/10 : 0,
      taken:  dbNet < 0 ? Math.round(-dbNet*10)/10 : 0,
      net:    Math.round(dbNet*10)/10,
      expiryRows: [],   // expiry detail isn't reconstructible without transactions
    };
  }
  var earned=txs.filter(function(t){return t.type==='add';}).reduce(function(s,t){return s+t.hours;},0);
  var taken=txs.filter(function(t){return t.type==='deduct';}).reduce(function(s,t){return s+t.hours;},0);
  var net=Math.round((earned-taken)*10)/10;
  // Build expiry rows: only show 'add' entries that haven't yet been offset by taken hours
  // Simple FIFO: assign taken hours against oldest earned first
  var earnedTxs=txs.filter(function(t){return t.type==='add';}).slice().sort(function(a,b){return a.date<b.date?-1:1;});
  var remainingTaken=taken;
  var expiryRows=[];
  earnedTxs.forEach(function(t){
    var hoursLeft=t.hours;
    if(remainingTaken>=hoursLeft){remainingTaken-=hoursLeft;return;} // fully consumed
    hoursLeft-=Math.min(remainingTaken,hoursLeft);remainingTaken=0;
    if(hoursLeft<=0)return;
    var earned=new Date(t.date);earned.setHours(0,0,0,0);
    var expiryDate=new Date(earned);expiryDate.setDate(expiryDate.getDate()+EXPIRY_DAYS);
    var daysLeft=Math.ceil((expiryDate-today)/(1000*60*60*24));
    // Auto-clear: if expired AND balance is zero or negative, skip silently
    if(daysLeft<=0&&net<=0)return;
    expiryRows.push({hours:hoursLeft,date:t.date,reason:t.reason,daysLeft:daysLeft,expiryDate:localDateStr(expiryDate)});
  });
  expiryRows.sort(function(a,b){return a.daysLeft-b.daysLeft;});
  return{earned:Math.round(earned*10)/10,taken:Math.round(taken*10)/10,net:net,expiryRows:expiryRows};
}
calc.getToilSummary = getToilSummary;

// v136.8: storeHint (optional) names the store when currentStore is not set yet: the
// boot reads balances before index.html restores the saved session, so a store till's
// boot read named no store and was refused ("store required"). currentStore still wins.
async function refreshBalances(storeHint) {
  try {
    var balRows = await DB.balances.list(new Date().getFullYear(), (typeof currentStore !== 'undefined' && currentStore) ? currentStore : ((typeof storeHint === 'string' && storeHint) ? storeHint : undefined));   // v131.38: tokenless reads name the store
    if (Array.isArray(balRows)) {
      balRows.forEach(function(r){
        // holiday_used and sick_used are now COMPUTED on the worker side
        // from the year's rota — no longer stored. Same shape as before so
        // the localStorage + in-memory caches keep working unchanged.
        var holRemaining = (r.holiday_total || 30) - (r.holiday_used || 0);
        var sickRemaining = (r.sick_total || 14) - (r.sick_used || 0);
        localStorage.setItem('elc_hol_bal_'   + r.staff_id, String(Math.max(0, holRemaining)));
        localStorage.setItem('elc_hol_total_' + r.staff_id, String(r.holiday_total || 30));
        localStorage.setItem('elc_sick_bal_'  + r.staff_id, String(Math.max(0, sickRemaining)));
        localStorage.setItem('elc_sick_total_'+ r.staff_id, String(r.sick_total || 14));
        holidayBalances[r.staff_id] = Math.max(0, holRemaining);
        sickBalances[r.staff_id] = Math.max(0, sickRemaining);
        toilBalances[r.staff_id] = r.toil_balance || 0;
      });
      dlog('[DB] Refreshed balances for ' + balRows.length + ' staff');
    }
  } catch(e) { /* silent: keep last-cached values */ }
}
calc.refreshBalances = refreshBalances;

// ── area ─────────────────────────────────────────────
export const area = {};

function renderAreaBalancesTab(myStores){
  var html='<table style="width:100%;border-collapse:collapse;font-size:12px"><thead><tr style="background:var(--surface-2)">';
  html+='<th style="padding:6px 10px;text-align:start;border-bottom:2px solid var(--border)">Name</th>';
  html+='<th style="padding:6px 8px;border-bottom:2px solid var(--border)">Store</th>';
  html+='<th style="padding:6px 8px;border-bottom:2px solid var(--border)">TOIL</th>';
  html+='<th style="padding:6px 8px;border-bottom:2px solid var(--border)">🌴 Holiday</th>';
  html+='<th style="padding:6px 8px;border-bottom:2px solid var(--border)">🤒 Sick</th>';
  html+='</tr></thead><tbody>';
  myStores.forEach(function(store){
    var staff=getStoreStaff(store);
    var displayNames=computeDisplayNames(staff);
    staff.forEach(function(s){
      var toil=(s.toilBalance||0);
      var hol=parseInt(localStorage.getItem('elc_hol_bal_'+s.id)||'30');
      var sick=parseInt(localStorage.getItem('elc_sick_bal_'+s.id)||'14');
      var toilColor=toil>0?'var(--green)':toil<0?'var(--red)':'var(--sub)';
      var holColor=hol<=5?'var(--red)':hol<=10?'var(--stores-amber)':'var(--sub)';
      var sickColor=sick<=2?'var(--red)':sick<=5?'var(--stores-amber)':'var(--sub)';
      html+='<tr style="border-bottom:1px solid var(--surface-3)">';
      html+='<td translate="no" style="padding:5px 10px;font-weight:600">'+escapeHtml(displayNames[s.id]||s.name.split(' ')[0])+'</td>';
      html+='<td style="padding:5px 8px;font-size:10px;color:var(--sub)">'+store.split(' - ').pop()+'</td>';
      html+='<td style="padding:5px 8px;text-align:center;font-weight:700;color:'+toilColor+'">'+formatToilDH(toil)+'</td>';
      html+='<td style="padding:5px 8px;text-align:center;font-weight:700;color:'+holColor+'">'+hol+'d</td>';
      html+='<td style="padding:5px 8px;text-align:center;font-weight:700;color:'+sickColor+'">'+sick+'d</td>';
      html+='</tr>';
    });
  });
  html+='</tbody></table>';
  document.getElementById('areaBalancesView').innerHTML='<div style="border:1px solid var(--border);border-radius:10px;overflow:hidden">'+html+'</div>';
}
area.renderAreaBalancesTab = renderAreaBalancesTab;

// ── toil ─────────────────────────────────────────────
export const toil = {};

async function onToilTabOpen() {
  renderToil();   // immediate paint with current-week data
  try {
    await loadFutureWeeksForProjections();
  } catch (e) {
    console.warn('[toil-tab] future-week load failed:', e && e.message);
    return;
  }
  renderToil();   // re-paint now that future shifts are in shifts[]
}
toil.onToilTabOpen = onToilTabOpen;

function renderToil(){
  var isAreaUser=currentUser&&(currentUser.role==='area_manager'||currentUser.role==='admin');
  var list=document.getElementById('toilList');
  list.innerHTML='';

  // Get the staff to display
  var staffToShow=[];
  if(isAreaUser){
    var storeFilter=document.getElementById('toilStoreFilter')?.value||'';
    var myStores=getMyStores();
    var storesToShow=storeFilter?[storeFilter]:myStores;
    storesToShow.forEach(function(store){
      getStoreStaff(store).forEach(function(s){staffToShow.push({s:s,store:store});});
    });
  } else {
    getStoreStaff(currentStore).forEach(function(s){staffToShow.push({s:s,store:currentStore});});
  }

  if(!staffToShow.length){
    list.innerHTML='<div style="text-align:center;padding:40px;color:var(--sub)">No staff found</div>';
    return;
  }

  // Group by store for multi-store view
  var byStore={};
  staffToShow.forEach(function(x){
    if(!byStore[x.store])byStore[x.store]=[];
    byStore[x.store].push(x.s);
  });

  Object.entries(byStore).forEach(function(entry){
    var store=entry[0],storeStaff=entry[1];
    var isQ=getStoreCountry(store)==='ELC - Qatar';

    // Store header for multi-store view
    if(isAreaUser&&Object.keys(byStore).length>1){
      var hdr=document.createElement('div');
      hdr.style.cssText='font-size:11px;font-weight:700;color:var(--sub);text-transform:uppercase;letter-spacing:.5px;padding:14px 0 6px';
      hdr.textContent=(isQ?'🇶🇦 ':'🇦🇪 ')+store;
      list.appendChild(hdr);
    }

    storeStaff.forEach(function(s){
      var sum=getToilSummary(s.id);
      var color=s.color||COLORS[s.id%COLORS.length];
      var holBal=holidayBalances[s.id]!==undefined?holidayBalances[s.id]:parseInt(localStorage.getItem('elc_hol_bal_'+s.id)||'30');
      var sickBal=sickBalances[s.id]!==undefined?sickBalances[s.id]:parseInt(localStorage.getItem('elc_sick_bal_'+s.id)||'14');

      var card=document.createElement('div');
      card.className='toil-card';
      card.style.cssText='flex-wrap:wrap;gap:12px';

      // v136.8 (security audit M3): the name, role and colour are stored text; escaped before innerHTML.
      var avatarHtml='<div style="background:'+escapeHtml(color)+';width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;flex-shrink:0">'+escapeHtml(initials(s.name))+'</div>';
      var nameHtml='<div style="flex:1;min-width:100px"><div translate="no" style="font-size:13px;font-weight:700">'+escapeHtml(String(s.name||'').split(' ')[0])+'</div><div style="font-size:11px;color:var(--sub)">'+escapeHtml(s.role)+'</div></div>';

      var toilDisplay=sum.net;
      var toilColor=toilDisplay>0?'var(--green)':toilDisplay<0?'var(--red)':'var(--sub)';
      // v81.3 — TOIL is now purely computed from the rota (worker.js /api/balances).
      // No baseline, no transactions, no clock-based credits. Display is the
      // headline net balance formatted as Xd Yh. The Earned/Upcoming sub-label
      // and Adjust button were removed — both pointed at a transaction model
      // that no longer exists. getProjectedToil/openToilModal are orphaned and
      // flagged for cleanup in a later cycle.
      var toilHtml='<div style="text-align:center;background:var(--stores-purple-soft);border-radius:10px;padding:8px 14px">';
      toilHtml+='<div style="font-size:18px;font-weight:800;color:'+toilColor+'">'+formatToilDH(toilDisplay)+'</div>';
      toilHtml+='<div style="font-size:10px;color:var(--sub);text-transform:uppercase;letter-spacing:.4px">TOIL</div>';
      toilHtml+='</div>';

      var holColor=holBal<=5?'var(--red)':holBal<=10?'var(--amber)':'var(--green)';
      // v79.15.1 — split holiday usage into past (used) and future (booked).
      // The "remaining" number ALREADY accounts for both, but splitting them
      // gives managers a clearer planning signal: used days are unrecoverable,
      // booked days are still changeable.
      var holTotalDisplay = parseInt(localStorage.getItem('elc_hol_total_'+s.id)||'30');
      var holBooked = getBookedHolidayDays(s.id);
      var holDeducted = holTotalDisplay - holBal;       // total taken-or-booked
      var holUsed = Math.max(0, holDeducted - holBooked); // past only
      var holHtml='<div style="text-align:center;background:var(--warn-bg);border-radius:10px;padding:8px 14px">';
      holHtml+='<div style="font-size:18px;font-weight:800;color:'+holColor+'">'+holBal+'</div>';
      holHtml+='<div style="font-size:10px;color:var(--sub);text-transform:uppercase;letter-spacing:.4px">Holiday days</div>';
      holHtml+='<div style="font-size:9px;color:var(--sub);margin-top:2px">of '+holTotalDisplay+'</div>';
      // Show the split when there's anything to split. Hide when everything's
      // 0 to avoid clutter on a fresh-year card.
      if (holUsed > 0 || holBooked > 0) {
        holHtml+='<div title="Used: days already taken in the past. Booked: future-dated holiday shifts on the rota that haven\'t happened yet." style="font-size:9px;color:var(--sub);margin-top:3px;border-top:1px dashed var(--stores-warn-line);padding-top:3px;display:flex;justify-content:center;gap:6px">';
        holHtml+='<span>Used '+holUsed+'</span><span>·</span><span>Booked '+holBooked+'</span>';
        holHtml+='</div>';
      }
      holHtml+='</div>';

      var sickColor=sickBal<=2?'var(--red)':sickBal<=5?'var(--amber)':'var(--stores-cyan)';
      var sickHtml='<div style="text-align:center;background:var(--danger-bg);border-radius:10px;padding:8px 14px">';
      sickHtml+='<div style="font-size:18px;font-weight:800;color:'+sickColor+'">'+sickBal+'</div>';
      sickHtml+='<div style="font-size:10px;color:var(--sub);text-transform:uppercase;letter-spacing:.4px">Sick days</div>';
      sickHtml+='<div style="font-size:9px;color:var(--sub);margin-top:2px">of '+parseInt(localStorage.getItem('elc_sick_total_'+s.id)||'14')+'</div>';
      sickHtml+='</div>';

      var expiryHtml='';
      if(sum.expiringSoon>0){
        var daysLeft=sum.daysUntilExpiry;
        var urgency=daysLeft<=5?'var(--red)':'var(--amber)';
        expiryHtml='<div style="width:100%;background:var(--warn-bg);border-radius:8px;padding:6px 10px;font-size:11px;color:var(--warn-deep)">⚠️ '+sum.expiringSoon.toFixed(1)+'h TOIL expires in '+daysLeft+' days</div>';
      }

      // v78: wrap the three balance sub-cards in a single flex container so
      // they stay together when the outer card wraps on narrow mobile screens.
      // Previously TOIL squeezed onto row 1 next to the name, while Holiday
      // and Sick wrapped to row 2 — visually separating TOIL from its siblings.
      // Now: either all three fit on row 1 (desktop), or the whole group wraps
      // together to row 2 (mobile).
      var balancesHtml='<div style="display:flex;gap:12px;flex-wrap:wrap">'+toilHtml+holHtml+sickHtml+'</div>';

      card.innerHTML=avatarHtml+nameHtml+balancesHtml+expiryHtml;
      list.appendChild(card);
    });
  });
}
toil.renderToil = renderToil;

async function runBalancesAiAnalysis(){
  var resultDiv=document.getElementById('toilAiResult');
  var textDiv=document.getElementById('toilAiText');
  resultDiv.style.display='block';
  textDiv.innerHTML='<div class="ai-dot"></div><div class="ai-dot"></div><div class="ai-dot"></div> Analysing balances across your stores...';

  var myStores=getMyStores();
  var storeFilter=document.getElementById('toilStoreFilter')?.value||'';
  var storesToAnalyse=storeFilter?[storeFilter]:myStores;

  // Build summary per person
  var summaryLines=[];
  var warnings=[];
  storesToAnalyse.forEach(function(store){
    var staff=getStoreStaff(store);
    staff.forEach(function(s){
      var sum=getToilSummary(s.id);
      var hol=parseInt(localStorage.getItem('elc_hol_bal_'+s.id)||'30');
      var holTotal=parseInt(localStorage.getItem('elc_hol_total_'+s.id)||'30');
      var sick=parseInt(localStorage.getItem('elc_sick_bal_'+s.id)||'14');
      var toilNet=sum.net;
      summaryLines.push(s.name.split(' ')[0]+' ('+store.split(' - ').pop()+'): TOIL='+(toilNet>0?'+':'')+toilNet.toFixed(1)+'h, Holiday='+hol+'/'+holTotal+'d, Sick='+sick+'d');
      if(toilNet>24)warnings.push(s.name.split(' ')[0]+' has '+toilNet.toFixed(1)+'h TOIL — over 3 days accrued');
      if(hol<=5)warnings.push(s.name.split(' ')[0]+' has only '+hol+' holiday days left');
      if(sick<=2)warnings.push(s.name.split(' ')[0]+' has only '+sick+' sick days remaining');
      if(sum.expiringSoon>0)warnings.push(s.name.split(' ')[0]+' has '+sum.expiringSoon.toFixed(1)+'h TOIL expiring soon');
    });
  });

  var prompt='You are reviewing staff leave and TOIL balances for ELC cosmetics retail stores.\n\n'+
    'Staff balances:\n'+summaryLines.join('\n')+'\n\n'+
    (warnings.length?'Auto-detected issues:\n'+warnings.join('\n')+'\n\n':'')+
    'Please provide:\n'+
    '1. Staff with the most urgent TOIL to use (high balance or expiring soon)\n'+
    '2. Anyone with dangerously low holiday or sick balances\n'+
    '3. Any patterns across stores worth flagging to management\n'+
    '4. Suggested actions for the top 3-5 most pressing cases\n'+
    'Be concise and prioritise by urgency. Use bullet points.';

  try{
    var data=await DB.ai.rota({model:'claude-haiku-4-5-20251001',max_tokens:800,
        system:'You are a retail HR analyst reviewing staff leave balances. Be concise, practical and prioritise urgent cases. Use bullet points.',
        messages:[{role:'user',content:prompt}]});
    var text=(data.content&&data.content[0]&&data.content[0].text)||'';
    textDiv.innerHTML=escapeHtml(text).replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>').replace(/^[•\-\*] /gm,'<br>• ').replace(/\n/g,'<br>');   // v132.89: model text escaped before formatting
  }catch(err){
    textDiv.innerHTML='❌ '+err.message;
  }
}
toil.runBalancesAiAnalysis = runBalancesAiAnalysis;

function addToilTx(staffId,type,hours,date,reason,auto){
  if(!toilBalances[staffId])toilBalances[staffId]=0;
  toilBalances[staffId]+=type==='add'?hours:-hours;
  toilTransactions.unshift({staffId:staffId,type:type,hours:hours,date:date,reason:reason,auto:auto||false});
  // v79.15.1 — persist the TOIL change to DB (memory-only before that; every
  // credit was lost on the next page load).
  // v127.27 (27 Jul audit P1) — persist the DELTA into toil_adjust, not a
  // computed balance — GET /api/balances recomputes TOIL from the rota plus
  // toil_adjust and ignores the stored balance column, so the old write was
  // DEAD. Two more deliberate changes ride along:
  //   • auto (rota-visible) events skip the save entirely — a TOIL day taken
  //     is a type='toil' shift the server already counts from the rota, so
  //     persisting it here would DOUBLE-COUNT the deduction;
  //   • the row carries ONLY staff_id/year/toil_adjust_delta — the old writer
  //     rebuilt holiday/sick totals from per-device localStorage (defaults
  //     30/14), clobbering the HR-reconciled holiday_total on every TOIL edit
  //     from a stale/fresh till. merge-duplicates preserves the columns a row
  //     doesn't carry, so the partial row is the safe write.
  // Best-effort: fire-and-forget. If the save fails, the local update still
  // shows in the UI for this session and a warning is logged. We don't
  // block the user with an await — existing call sites are sync.
  if (!auto && typeof DB !== 'undefined' && DB.balances && DB.balances.save) {
    var year = (date && /^\d{4}/.test(date)) ? parseInt(date.slice(0,4)) : new Date().getFullYear();
    var delta = type==='add' ? hours : -hours;
    var row = {
      staff_id: staffId,
      year: year,
      toil_adjust_delta: Math.round(delta*10)/10,
    };
    // Wrap with auth-retry so a TTL-expired auth-pin re-prompts rather than
    // failing silently. Existing pattern from v79.15 (see clearWeeklyRota,
    // shift save).
    var saveFn = function(){ return DB.balances.save(row); };
    var promise;
    if (typeof withRetryOnAuthExpiry === 'function') {
      promise = withRetryOnAuthExpiry(saveFn, 'updating TOIL balance');
    } else {
      promise = saveFn();
    }
    promise.catch(function(e){
      console.warn('[TOIL] DB persist failed for staff ' + staffId + ': ' + (e && e.message));
      // Toast only for manual user-initiated changes — auto-grants happen
      // silently in the background and a toast would be alarming/confusing.
      if (!auto && typeof showToast === 'function') {
        showToast('TOIL change shown locally but DB save failed \u2014 refresh to recover', 'error');
      }
    });
  }
}
toil.addToilTx = addToilTx;

function openToilModal(staffId){
  currentToilStaff=staffId;
  var s=ALL_STAFF.find(function(x){return x.id===staffId;});
  var sum=getToilSummary(staffId);
  document.getElementById('tmName').textContent=s.name+' \u2014 TOIL';
  document.getElementById('tmBalance').textContent='Balance: '+(sum.net>0?'+':'')+sum.net.toFixed(1)+'h (Earned '+sum.earned.toFixed(1)+'h, Taken '+sum.taken.toFixed(1)+'h)';
  document.getElementById('tmHours').value='8';document.getElementById('tmType').value='add';
  document.getElementById('tmReason').value='';document.getElementById('tmDate').value=todayStr();
  document.getElementById('toilModal').classList.add('open');
}
toil.openToilModal = openToilModal;

function closeToilModal(){document.getElementById('toilModal').classList.remove('open');}
toil.closeToilModal = closeToilModal;

function saveToil(){
  var type=document.getElementById('tmType').value;
  var hours=parseFloat(document.getElementById('tmHours').value)||0;
  var date=document.getElementById('tmDate').value;
  var reason=document.getElementById('tmReason').value.trim();
  if(!reason){showToast('Enter a reason','error');return;}
  if(hours<=0){showToast('Enter valid hours','error');return;}
  addToilTx(currentToilStaff,type,hours,date,reason);
  closeToilModal();showToast('TOIL updated','success');renderToil();
}
toil.saveToil = saveToil;
